'use strict';

/*
  Base class for processing Braintree payments.

  Must be initialized as a data-mogo-page component.
*/
function _BTPayment() {
  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this.extends = [CustomerPayments];

  /*
    Add any BT modules to this list that are required, this.btReady will be
    executed once all libraries are loaded.
  */
  this.requiredBtDependencies = {
    client: true
    /*
    "hosted-fields": true,
    "paypal-checkout": true
    */
  };

  // BT variables
  this.btClient = null;

  this._BT_LIBRARIES_URL = 'https://js.braintreegateway.com/web/3.23.0/js/';
  this._PAYPAL_CHECKOUTJS = 'https://www.paypalobjects.com/api/checkout.js';
  // this._SANDBOX_CLIENT_AUTHORIZATION_TOKEN = "sandbox_nh8kg2s7_hz2pz7qq6ttx3fkx";
  this._SANDBOX_CLIENT_AUTHORIZATION_TOKEN = null;

  this._env = 'sandbox';
  this._clientAuthorization = '';
  this._requiredBtDependencies = {};

  this.init = function () {
    this.initBTPayment();
  };

  this.initAllReady = function () {};

  this.initBTPayment = function () {
    if (location.hostname === 'www.mogo.ca') {
      this._env = 'production';
    }
    this._loadLibraries();
  };

  /*
    Fires when Braintree Payment modules and dependencies are ready.
     Child class should overload this method and provide implementation.
  */
  this.btReady = function () {
    // Child class provides implementation
    // ...
  };

  this.btError = function (error) {
    // Child class provides implementation
    // ...
  };

  this._loadLibraries = function () {
    this._requiredBtDependencies = {};
    // Load libraries
    this._btClassMapping = {};
    var deferredArray = [];
    for (var key in this.requiredBtDependencies) {
      this._btClassMapping[key] = this._mapLibraryToClass(key);
      if (this.requiredBtDependencies[key]) {
        // Create deferred and add to array to be invoked by apply
        this._requiredBtDependencies[key] = $.Deferred();
        deferredArray.push(this._requiredBtDependencies[key]);

        if (typeof braintree !== 'undefined' && braintree && braintree[this._btClassMapping[key]]) {
          // Library already loaded
          this._requiredBtDependencies[key].resolve();
        } else {
          // Load library
          $.ajax({
            url: this._BT_LIBRARIES_URL + key + '.min.js',
            dataType: 'script',
            success: this._requiredBtDependencies[key].resolve,
            error: this._requiredBtDependencies[key].reject
          });
        }
      }
    }

    // Retrieve payment methods
    this._requiredBtDependencies.paymentMethods = this.retrievePaymentMethods();

    // Retrieve client authorization token
    deferredArray.push(this._retrieveClientAuthorization());

    // Retrieve checkout.js (Paypal)
    if (this._requiredBtDependencies['paypal-checkout']) deferredArray.push(this._retrievePaypalExpressCheckout());

    // Setup resolution
    $.when.apply(null, deferredArray).done(this._createClient.bind(this));
    $.when.apply(null, deferredArray).fail(this._onLoadLibrariesError.bind(this));
  };

  this._onLoadLibrariesError = function () {
    // Parse error
    var error = {};
    for (var key in this._requiredBtDependencies) {
      error[key] = {};
      error[key].error = this._requiredBtDependencies[key].state() === 'reject';
    }
    this.btError(error);
  };

  this._createClient = function () {
    braintree.client.create({
      authorization: this._clientAuthorization
    }, this._onClientCreate.bind(this));
  };

  this._onClientCreate = function (clientErr, clientInstance) {
    if (clientErr) {
      throw new Error('Braintree client initialization error: ' + clientErr.toString());
    }
    this.btClient = clientInstance;
    this.btReady();
  };

  this._retrievePaypalExpressCheckout = function () {
    this._requiredBtDependencies['checkout.js'] = $.Deferred();
    if (typeof paypal === 'undefined' || !paypal) {
      $.ajax({
        url: this._PAYPAL_CHECKOUTJS,
        dataType: 'script',
        success: this._requiredBtDependencies['checkout.js'].resolve,
        error: this._requiredBtDependencies['checkout.js'].reject
      });
    } else {
      this._requiredBtDependencies['checkout.js'].resolve();
    }
    return this._requiredBtDependencies['checkout.js'];
  };

  this._retrieveClientAuthorization = function () {
    this._requiredBtDependencies.clientAuthorization = $.Deferred();
    if (this._env === 'production') {
      this.presenter.performAction('account.get_payment_method_token', null, this._onRetrieveClientAuthorizationToken.bind(this));
    } else if (this._SANDBOX_CLIENT_AUTHORIZATION_TOKEN) {
      this._clientAuthorization = this._SANDBOX_CLIENT_AUTHORIZATION_TOKEN;
      this._requiredBtDependencies.clientAuthorization.resolve();
    } else {
      this.presenter.performAction('account.get_payment_method_token', null, this._onRetrieveClientAuthorizationToken.bind(this));
    }
    return this._requiredBtDependencies.clientAuthorization;
  };

  this._onRetrieveClientAuthorizationToken = function (data, response) {
    if (response === 200) {
      this._clientAuthorization = data.token;
      this._requiredBtDependencies.clientAuthorization.resolve();
      return;
    }
    this._requiredBtDependencies.clientAuthorization.reject();
  };

  this._mapLibraryToClass = function (library) {
    if (this._btClassMapping[library]) return this._btClassMapping[library];

    return library.replace(/-([a-z])/g, function (g) {
      return g[1].toUpperCase();
    });
  };

  this.destroy = function () {};
}